import api from './index'

export default {

    /**
     * Create an export of expenses
     * @param data
     */
    createExpenses(data) {
        return api
            .post(`/export/expenses`, data)
            .then(response => {
                return response.data
            })
    },

    /**
     * Get an export
     * @param export ID (UUID)
     * @param params
     */
    show(id, params) {
        return api
            .get(`/exports/${id}`, { params: params })
            .then(response => {
                return response.data
            })
    },

    /**
     * Download an export
     * @param export ID (UUID)
     * @param params
     */
    download(id, params) {
        return api
            .get(`/exports/${id}/download`, {
                params: params,
                responseType: 'blob'
            })
            .then(response => {
                return response.data
            })
    }

}
